declare const Lucia: any;

/**
 * This function allows us to track client-side events via our front-end Typescript/React code.
 * We also do some automatic tracking of client-side events via `rails/app/assets/javascripts/tracking.js`, where
 * we automatically track pageviews, clicks, and change events.
 * That file defines a function `Lucia.tracking.event`, which tracks client-side events in Mixpanel and Customer.io.
 * This `trackEvent` function is just a wrapper of the `Lucia.tracking.event` function.
 */
export function trackEvent(eventName: string, properties: {}) {
  Lucia.tracking.event(eventName, properties);
}
